<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">认知汇总</span>
      <span class="zn-text-grey"></span>
    </div>
    <div class="zn-template-content" ref="tplContent" v-loading="loading" style="flex:1;padding:0 10px;top:50px;display:flex;flex-direction:column;">
      <div style="padding-bottom:10px;display:flex;align-items:center;font-size:14px">
        <span style="flex:none;">公司：</span>
        <el-autocomplete
          v-model="companyName"
          size="small"
          :fetch-suggestions="querySearch"
          placeholder="输入公司名称，点击选择"
          @select="selectCompany"
          style="flex:1;margin-right:20px;"
        >
        </el-autocomplete>
        <span style="flex:none;">职能模块：</span>
        <el-select
          v-model="categoryId" filterable size="small" @change="loadData"
          style="flex:1;"
        >
          <el-option v-for="item in categories" :key="item._id" :label="item.name" :value="item._id">
            <span style="float: left">{{ item.name }}</span>
            <span v-if="item.hasFile" style="float: right; color: #92BFD4; font-size: 13px">有附件</span>
          </el-option>
        </el-select>
      </div>
      <div style="position:relative" class="renzhi-tab">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="公司认知" name="公司认知">
          </el-tab-pane>
          <el-tab-pane label="职能认知" name="职能认知">
          </el-tab-pane>
          <el-tab-pane label="职能附件" name="职能附件">
          </el-tab-pane>
        </el-tabs>
        <el-button size="mini" type="text" @click="goto('newTalentFlow')" style="position:absolute;top:5px;right:5px;">
          查看职能人才流动
        </el-button>
        <el-button size="mini" type="text" @click="goto('knowledgebase')" style="position:absolute;top:5px;right:110px;">
          查看知识库
        </el-button>
        <div>
          <span class="el-icon-s-order"></span>
          <span style="font-size:13px;font-weight:bold;line-height:40px">{{ activeName }}汇总:</span>
          <span style="font-size:13px;color:#a7a7a7">{{subtitle}}</span>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;" :style="{ overflow: activeName == '职能附件' ?'visible':'auto'}">
        <div v-if="!categoryId && activeName != '公司认知'" style="overflow:auto;padding:10px;">
          <div v-if="companyCates.length > 0" style="display:flex">
            <div style="line-height:28px;width:90px;flex:none">职能模块：</div>
            <div>
              <el-button v-for="(name, k) in companyCates" :key="k" type="text" size="mini" @click="chooseCate(name)" style="margin:0 5px;color:#92BFD4">{{name}}</el-button>
            </div>
          </div>
          <div v-else style="display:flex">
            <div style="line-height:28px;width:90px;flex:none">职能模块：</div>
            <div>
              <el-button v-for="(name, k) in defaultCates" :key="k" type="text" size="mini" @click="chooseCate(name)" style="margin:0 5px;color:#92BFD4">{{name}}</el-button>
            </div>
          </div>
        </div>
        <div v-if="!companyName && activeName != '职能附件'" style="overflow:auto;padding:10px;">
          <div v-if="clientNames.length > 0" style="display:flex">
            <div style="line-height:28px;width:90px;flex:none">客户公司：</div>
            <div>
              <el-button v-for="(name, k) in clientNames" :key="k" type="text" size="mini" @click="chooseCompany(name)" style="margin:0 5px;color:#92BFD4">{{name}}</el-button>
            </div>
          </div>
          <div v-for="(clients, label) in defaultClients" :key="label" style="display:flex">
            <div style="line-height:28px;width:90px;flex:none">{{ label }}：</div>
            <div>
              <el-button v-for="(name, k) in clients" :key="k" type="text" size="mini" @click="chooseCompany(name)" style="margin:0 5px;color:#92BFD4">{{name}}</el-button>
            </div>
          </div>
        </div>
        <div v-if="activeName == '公司认知'" style="display:flex;flex-direction:column;overflow:auto;">
          <div style="overflow:auto;padding:10px;">
            <div v-if="alphaLogs.length>0">
              <div v-for="(item, index) in alphaLogs" :key="index">
                <span class="remark-date">
                  <span class="remark-time">{{ dateFormat((item.updatedAt||item.createdAt), 'yyyy-mm-dd HH:MM') }} -- {{ item.account }}<i v-if="isAdmin || item.account===account" class="el-icon-delete ml10" style="flex:none;color:#de5c65;cursor:pointer;" @click="alphaCognitiveRemoveLog(item)"></i></span>
                </span>
                <pre class="remark-info pd-10" style="white-space:pre-wrap;margin-top:5px">{{ item.content }}</pre>
              </div>
            </div>
            <p v-else-if="companyName" style="text-align: center;color: #a7a7a7;">该条件下目前没有填写过认知哦</p>
          </div>
          <div v-if="companyName" style="padding-top:10px;">
            <el-input v-model="alphaRenzhi" type="textarea" placeholder="请输入并保存" :rows="3" class="renzhi-textarea"></el-input>
            <div style="padding:5px 0;text-align:right">
              <el-button size="mini" style="background:#85AFDA;border-color:#85AFDA" type="primary" @click="alphaCognitiveAddLog(true)">保存</el-button>
            </div>
          </div>
        </div>
        <div v-if="activeName == '职能认知'" style="display:flex;flex-direction:column;overflow:auto;">
          <div v-if="categoryId && companyName" style="overflow:auto;padding:10px;">
            <p v-if="showTip" style="text-align: center;color: #a7a7a7;">该条件下目前没有填写过认知哦</p>
            <div v-for="(item, index) in allRemarks" :key="index">
              <span class="remark-date">
                <span class="remark-time">{{ dateFormat(item.createdAt, 'yyyy-mm-dd HH:MM') }}</span>
                {{ item.account }}
              </span>
              <pre class="remark-info pd-10" style="white-space:pre-wrap;margin-top:5px">{{ item.content }}</pre>
            </div>
          </div>
          <div v-if="categoryId && companyName" style="padding-top:10px;">
            <div>
              <el-input v-model="log" type="textarea" placeholder="可以输入跟当前公司有关的任何信息" :rows="3" class="renzhi-textarea"></el-input>
            </div>
            <div style="padding:5px 0;text-align:right">
              <el-button size="mini" type="primary" @click="saveLogFunc" style="background:#85AFDA;border-color:#85AFDA">
                保存
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="activeName == '职能附件'" style="padding:10px;">
          <div v-if="categoryId" style="position:relative">
            <el-button v-if="categoryId" size="mini" type="primary" style="position:absolute;top:-40px;right:5px;background:#85AFDA;border-color:#85AFDA;margin-top:5px" @click="showChooseFileType">上传职能附件</el-button>
            <div>
              <el-table
                :data="files"
                size="mini"
                :border="true"
                style="width: 100%">
                <el-table-column
                  prop="originalname"
                  label="文件名">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="preview(scope.row)">{{ scope.row.originalname }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="上传时间"
                  width="100">
                  <template slot-scope="scope">
                    {{ dateFormat(scope.row.createdAt) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="上传人"
                  width="100"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.提供者 || scope.row.uploader && scope.row.uploader.toString() }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="系统来源"
                  width="100"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.来源 || '知识库' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="!categoryId" style="padding-top:100px">
        <div style="position:relative;width:400px;margin:0 auto;text-align:right;">
          <div
            class="el-popover el-popper el-popover--plain"
            style="width: 160px; position: absolute; top: -50px; left: 50px; transform-origin: center bottom;"
            x-placement="top"
          >
            <span style="color:#888">请先选择职能模块</span>
            <div class="popper__arrow" style="left: 113.5px;"></div>
          </div>
          <img src="../../../assets/images/xiaoa.png" style="width:300px">
        </div>
      </div> -->
    </div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false">
      <el-alert title="请选择附件类型" type="success"></el-alert>
      <div class="mb5">
        <span class="title label">附件：</span>
        <el-select v-model="fileType" class="content" filterable size="mini">
          <el-option v-for="item in fileTypeOption" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <div class="mb5">
        <span class="title label">提供者：</span>
        <el-select v-model="provider" class="content" filterable size="mini">
          <el-option v-for="item in accounts" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <div>
        <span>备注:</span>
        <el-input v-model="remark" type="textarea" :rows="2" placeholder="备注"> </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="onCancel">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="onConfirm">确 定</div>
      </span>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      categoryId: '',
      categoryName: '',
      companyId: '',
      companyName: '',
      categories: [],
      allRemarks: [],
      loading:false,
      user:'',
      files: [],
      fileTypeOption: ['职能模块介绍', '答辩ppt', '职能模块培训'],
      dialogVisible: false,
      remark: '',
      fileType: '',
      provider: '',
      isShow: false,
      accounts: [],
      showTip: false,
      log: '',
      activeName: '公司认知',
      alphaLogs: [],
      alphaRenzhi: '',
      isAdmin: false,
      account:'',
      clientNames: [],
      defaultClients: {
        头部券商: ['中金公司','中信证券','广发证券','国泰君安','华泰证券','招商证券'],
        头部公募基金: ['嘉实基金','易方达基金','广发基金','华夏基金','博时基金','南方基金'],
        头部医药: ['信念医药','科兴中维','辉瑞','赛诺菲','西安杨森'],
      },
      defaultCates: ['IBD-投行','FI-债券开发执行','QUANT-量化投资','FIR-固收研究','RI-研究','FOF-FOF','IS-机构销售','FII-固收投资','DS-渠道销售','EQ-股票投资','PEVC-股权投资','IT-信息技术','医药-BD','医疗-设备销售'],
      companyCates: [],
      catesWithFile: [
        'ABS-资产证券化','AMC-不良资产处置','Admi&Sec-行政文秘','Alpha-内招','Audit-审计','BB-经纪业务','BD-客户拓展','BIG4-四大','BS-董秘','CF-消费金融','CFO-财务总监','COM-合规','Consult-咨询',
        'DCM-债券DCM','DS-渠道销售','ECM-股本ECM','EQ-股票投资','EQS-股票销售','FA-融资顾问','FATA-运营','FI-债券开发执行','FII-固收投资','FIN-财务','FIR-固收研究','FIS-债券销售','FOF-FOF',
        'FOF-母基金（一级市场）','FT-债券交易','HK-IBD','HKDCM-香港DCM','HKECM-香港ECM','HR-人力','Headhunter-猎头','IBD-投行','IR-投资者关系','IS-机构销售','KC-内核','LEGAL&COM-法务合规',
        'LEGAL-律所','MF-夹层基金','MKT-市场营销','MO-中台支持','NS-非标','OM-运营管理','PDT-产品','PEVC-股权投资','PM-投后管理','PR-公关','PS-产品销售','QC-质控','QDII-海外投资（二级市场）',
        'QUANT-量化投资','QUANT-量化研究','REI-地产投资','RI-研究','RISK-风控','RM-客户经理','RO-香港金融机构持牌人','SI-战略投资','SR-战略研究','TD-交易员','WM-财富管理','互联网-AI/算法产品',
        '互联网-NET运营','互联网-AI/算法产品','互联网-NET运营','互联网-交易产品','互联网-产品管理岗','互联网-前端开发','互联网-后端开发','互联网-基础技术-硬件','互联网-基础技术-软件','互联网-数据',
        '互联网-测试','互联网-算法','互联网-运维','互联网-项目管理','互联网行业','公募REITs','其他','医疗-器械耗材销售','医疗-研发工程师','医疗-研发项目管理','医疗-硬件开发','医疗-设备销售','医疗-质量管理',
        '医药-BD','医药-上市前医学','医药-临床前','医药-临床前研究','医药-临床运营CO','医药-医学事务MED','医药-注册申报RA','医药-生产制造CMC','医药-药品生产/质量管理','医药-运营管理','品牌-PR-GR','技术部内部',
        '投融资','新能源','芯片-AE','芯片-Chiplet','芯片-EDA','芯片-FAE','芯片-IC','芯片-产品','芯片-光学','芯片-器件','芯片-封装','芯片-数字芯片','芯片-数模混合芯片','芯片-晶圆制造','芯片-机器人',
        '芯片-模拟芯片','芯片-硬件','芯片-算法','芯片-结构力学','芯片-质量','芯片-软件','芯片-销售','芯片-项目管理','芯片-验证','衍生品投资','运营管理','金融科技-IT信息技术','金融科技-IT团队管理','金融科技-云平台',
        '金融科技-交互体验设计师','金融科技-产品经理','金融科技-企业软件','金融科技-前端开发','金融科技-后端开发'
      ]
    }
  },
  computed: {
    subtitle() {
      if (!this.companyName && this.activeName == '公司认知') {
        return '（以下为系统已有头部公司）'
      }
      if (!this.categoryId && this.activeName == '职能认知') {
        return this.companyName?'（以下为该公司已有认知的职能）':'（您可能想看以下职能）'
      }
      if (!this.categoryId && this.activeName == '职能附件') {
        return '（您可能想看以下职能）'
      }
    }
  },
  async mounted(){
    if (!app.accounts) await app.getUsers()
    this.accounts = app.accounts
    if (!app.categories) await app.getCats()
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
    this.account = app.user.account
    // 客户公司
    if (!app.projects) {
      await app.getProjects()
    }
    this.clientNames = Array.from(new Set(app.projects.map(p=>p.客户公司).slice(0, 15)))
  },
  methods: {
    initData() {
      this.categoryId = ''
      this.categoryName = ''
      this.companyId = ''
      this.companyName = ''
      this.allRemarks = []
      this.files = []
      this.dialogVisible = false
      this.remark = ''
      this.fileType = ''
      this.provider = ''
      this.log = ''
      this.showTip = false
      this.activeName = '公司认知'
      this.alphaLogs = []
      this.alphaRenzhi = ''
      this.companyCates = []
      const categories = JSON.parse(JSON.stringify(app.categories.map((v) => {
        return { name: v.名称, _id: v._id, 类型: v.类型, hasFile: this.catesWithFile.includes(v.名称)  }
      })))
      categories.sort((n, c) => n.hasFile && !c.hasFile ? -1 : 1)
      this.categories = categories
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    async loadData(){
      if (this.loading) return this.$message.error('搜索中，请稍等')
      if (!this.categoryId) return this.$message.error('请选择职能模块')
      this.loading = true
      try {
        const cate = this.categories.find(c=>c._id == this.categoryId)
        if (cate) {
          this.categoryName = cate.name
        }
        // 知识库附件
        const res = await app.service('company').getKnowledgeAtta({ categoryId: this.categoryId })
        if (res.status === 'success') {
          let files = res.data
          // 项目附件
          if (this.categoryName) {
            const res2 = await app.service('project').getProjectFilesByCate({ cate: this.categoryName })
            if (res2.status == 'success') {
              files = files.concat(res2.data)
            }
            if (this.companyName) {
              this.loading = false
              await this.loadRenzhi()
            }
          }
          files.sort((a, b) => b.createdAt - a.createdAt)
          if (cate && cate.类型 == '金融-职能') {
            files.unshift({ originalname:'【视频】金融地图', url:'https://vod.aconsulting.top/sv/350cba1c-18418271820/350cba1c-18418271820.mp4', 来源:'培训' })
            if (this.categoryName == 'IBD-投行') {
              files.unshift({ originalname:'【视频】投行行业认知', url:'https://vod.aconsulting.top/sv/2f951b12-18419226b9f/2f951b12-18419226b9f.mp4', 来源:'培训' })
            } else if (this.categoryName == 'PEVC-股权投资') {
              files.unshift({ originalname:'【视频】PEVC行业认知', url:'https://vod.aconsulting.top/sv/6341b437-184182706cb/6341b437-184182706cb.mp4', 来源:'培训' })
            } else if (['QUANT-量化研究','QUANT-量化投资','FII-固收投资','EQ-股票投资','FIR-固收研究','RI-研究','FOF-FOF','IS-机构销售','DS-渠道销售'].includes(this.categoryName)) {
              files.unshift({ originalname:'【视频】公募基金行业认知', url:'https://vod.aconsulting.top/sv/4c16b914-1841826f6b7/4c16b914-1841826f6b7.mp4', 来源:'培训' })
            }
          }
          this.files = files
        } else {
          this.$message.error(res.msg)
        }
        if (!this.companyName && this.activeName == '公司认知') this.activeName = '职能附件'
      } catch (error) {
        this.$message.error(error.message)
      }
      this.loading = false
    },
    async loadRenzhi() {
      if (this.loading) return this.$message.error('搜索中，请稍等')
      this.loading = true
      try {
        this.companyCates = []
        if (this.companyId) {
          const resCate = await app.service('company').getComCateCognition(this.companyId)
          if (resCate.status === 'success') {
            this.companyCates = resCate.data.map(dt=>dt.职能模块)
            this.categories = app.categories.filter(v=>this.companyCates.includes(v.名称)).map((v) => {
              return { name: v.名称, _id: v._id, 类型: v.类型  }
            })
          }
        }
        this.allRemarks = []
        if (this.companyName && this.categoryName) {
          const res = await app.service('company').searchComCateCognitionLogs({
          职能模块: [this.categoryName],
          公司: this.companyName
        })
        if (res.status === 'success') {
          this.allRemarks = res.data
        } else {
          this.$message.error(res.msg)
        }
      }
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.showTip = !this.allRemarks.length
      }
      this.loading = false
    },
    initRenzhi() {
      this.companyId = ''
      this.companyName = ''
      this.allRemarks = []
      this.log = ''
    },
    async saveLogFunc() {
      if (!this.log) return this.$message.error('请填写要保存的内容')
      if(!this.companyId) return this.$message.error('请填写公司')
      if(!this.categoryName) return this.$message.error('公司不存在')
      const savelog = {
        createdAt: new Date().getTime(),
        account: app.user.account,
        content: this.log,
      }
      const res = await app.service('company').comCateCognitionAddLog({
        cid: this.companyId,
        category: this.categoryName,
        log: savelog,
      })
      if (res.status === 'success') {
        await this.loadRenzhi()
        this.log = ''
      } else {
        this.$message.error(res.msg)
      }
    },
    selectCompany(item) {
      this.companyId = item._id
      this.companyName = item.简称
      const logs = item.阿尔法认知 || []
      logs.sort((a, b) => b.updatedAt - a.updatedAt)
      this.alphaLogs = logs
      this.loadRenzhi()
      if (!this.categoryId && this.activeName == '职能附件') this.activeName = '公司认知'
    },
    async chooseCompany(name) {
      const res = await app.service('company').getCompany({ 简称: name })
      if (res.status == 200) {
        this.selectCompany(res.result)
      }
    },
    async chooseCate(name) {
      const cate = this.categories.find(c=>c.name == name)
      if (cate) {
        this.categoryName = cate.name
        this.categoryId = cate._id
        await this.loadData()
      }
    },
    async querySearch(queryString, cb) {
      const results = queryString ? await this.searchCompanyName(queryString) : []
      if (!queryString) {
        this.companyId = ''
        this.companyName = ''
        this.allRemarks = []
        this.log = ''
        this.showTip = false
        this.alphaLogs = []
        this.alphaRenzhi = ''
        this.companyCates = []
        this.categories = app.categories.map((v) => {
          return { name: v.名称, _id: v._id, 类型: v.类型  }
        })
      }
      cb(results)
    },
    async searchCompanyName(name) {
      name = name.trim()
      if (!name) return []
      const res = await app.service('company').serchCompany(name)
      const sliceArr = res.data.slice(0, 10)
      const isClient = sliceArr.filter(v => v.公司阶段 === '已签约')
      const isNotClient = sliceArr.filter(v => v.公司阶段 !== '已签约')
      const arr = []
      if (isClient.length > 0) {
        const companies = isClient.map(val => ({
          value: `${val.简称}${val.公司名称 ? `（${val.公司名称}）` : ''}${val.公司类型 ? `（${val.公司类型}）` : ''}${
            val.客户开发 ? `（${val.客户开发}）` : ''
          }`,
          简称: val.简称,
          _id: val._id,
          阿尔法认知: val.阿尔法认知,
        }))
        arr.push(...companies)
      }
      if (isNotClient.length > 0) {
        const companies = isNotClient.map(val => ({
          value: `${val.简称}${val.公司名称 ? `（${val.公司名称}）` : ''}（非客户）`,
          简称: val.简称,
          _id: val._id,
          阿尔法认知: val.阿尔法认知,
        }))
        arr.push(...companies)
      }
      return arr
    },
    async preview(file) {
      if (file.url) {
        file.title = file.originalname
        app.root.$refs.PeixunDia.open(file)
      } else {
        const ref = app.root.$refs.cvPreview
        if (!ref) return
        await ref.getFile(file)
        ref.show()
      }
    },
    goto(url) {
      window.open(`${window.frontend}/#/${url}`)
    },
    showChooseFileType() {
      this.remark = ''
      this.fileType = ''
      this.provider = ''
      this.dialogVisible = true
    },
    onCancel() {
      this.dialogVisible = false
    },
    onConfirm() {
      if (!this.fileType) return this.$message.error('请选择文件类型')
      this.isShow = true
      this.dialogVisible = false
      this.$refs.upload.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      try {
        const option = {
          remark: this.remark,
          createdAt: new Date().getTime(),
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          label: '职能模块',
          type: this.fileType || '其他',
          categoryId: this.categoryId,
          提供者: this.provider,
          isShow: this.isShow,
        }
        const result = await app.service('company').insertKnowledgeAtta(option)
        if (result.status === 'success') {
          this.$message.success(`上传成功`)
          this.files.unshift(result.data)
        } else {
          this.$message.error(`上传失败,${result.msg}`)
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async alphaCognitiveAddLog(confirm = false){
      if (!this.alphaRenzhi) return this.$message.error('请填写要保存的内容')
      const log = { updatedAt: Date.now(), account: app.user.account, content: this.alphaRenzhi }
      this.alphaRenzhi = ''
      const res = await app.service('company').alphaCognitiveAddLog({
        cid: companyId,
        log: log,
      })
      if (res.status === 'success') {
        this.alphaLogs.unshift(log)
      }
    },
    async alphaCognitiveRemoveLog(log){
      this.$confirm('确定要移除这条日志吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await app.service('company').alphaCognitiveRemoveLog({
          cid: companyId,
          log: log,
        })
        if (res.status === 'success') {
          this.$message.success('移除成功')
          this.alphaLogs = this.alphaLogs.filter(a=>a.updatedAt != log.updatedAt && a.account != log.account)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
  },
}
</script>
<style>
.renzhi-tab .el-tabs__item {
  font-size: 12px;
}
.renzhi-textarea .el-textarea {
  border-color: #85afda;
}
</style>
